import { useTranslation } from 'react-i18next';

import { formatCurrency } from 'support/helpers/currency/currency';

type SubtotalProps = {
  amount: number;
  currency: string | undefined;
};

export function Subtotal({ amount, currency }: SubtotalProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between">
      <dt className="text-xs font-normal leading-4 text-gray-500">{t('orderForms:checkout.subtotal')}</dt>
      <dd className="text-xs font-medium leading-4 text-gray-700">{formatCurrency(amount, currency)}</dd>
    </div>
  );
}
